import React, { useEffect, useState } from "react";
import "@/App.css";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Manifesto from "./components/Manifesto";
import Impact from "./components/Impact";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Education from "./components/Education";
import Footer from "./components/Footer";

export default function App() {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const saved = localStorage.getItem("gfolio-theme");
    const initial = saved === "light" || saved === "dark" ? saved : "light";
    setTheme(initial);
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    html.classList.remove("light", "dark");
    html.classList.add(theme);
    localStorage.setItem("gfolio-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <div className="App grain" data-testid="app-root" data-theme={theme}>
      <Nav theme={theme} onToggleTheme={toggleTheme} />
      <main>
        <Hero />
        <Manifesto />
        <Impact />
        <Projects />
        <Experience />
        <Skills />
        <Education />
        <Footer />
      </main>
    </div>
  );
}
